import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid } from '@mui/material';
import Heading from '../../Components/Heading';
import Paragraph from '../../Components/Paragraph';
import world from '../../../assets/worldold.png';
import worldmobile from '../../../assets/world.png';
import noderight from '../../../assets/noderight.png';
import SubHeading from '../../Components/SubHeading';
import PurpleButton from '../../Components/PurpleButton';
import Aos from 'aos';

const Wrapper = styled(Box)`
  padding: 100px 0px;
  position: relative;
`;

const CardSection = styled(Box)`
  background: #070616;
  border-radius: 20px;
  transition: all 0.3s ease;
  border: 1px solid #222222;
  flex: 1;
  position: relative;
  z-index: 3;
`;

const StyledSubHeading = styled(SubHeading)`
  color: #ffffff;
  margin-bottom: 14px;
  font-size: 48px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 1065px) {
    font-size: 32px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 600px) {
    font-size: 26px;
    margin-bottom: 10px;
  }
`;

const GridMobile = styled(Grid)`
  @media (max-width: 600px) {
    padding: 20px !important;
  }
`;

const WorldImage = styled(Box)`
  width: 100%;
  height: auto;
  z-index: 2;
  position: relative;

  @media (max-width: 1530px) {
    display: none;
  }
`;

const WorldMobileImage = styled(Box)`
  display: none;
  width: 100%;
  height: auto;
  z-index: 2;
  position: relative;

  @media (max-width: 1530px) {
    display: block;
  }
`;

const StatCardBase = `
  width: 150px;
  height: 120px;
  background: #070616;
  border: 0.5px solid #222;
  border-radius: 16px;
  padding: 14px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  opacity: 0;
  transform: translateY(10px);
  animation: fadeUpCard 0.8s ease forwards 0.9s, smoothMovingShadow 3s ease-in-out infinite 1s;

  /* Constant animation - same as your hover but always running */
  box-shadow: 
    0 2px 3px 0 #FFF inset,
    0 0 116.1px -53px #7300FF inset,
    0 41px 66.9px -33px #CB60FA inset,
    0 4px 20px rgba(0, 0, 0, 0.3);

  h2 {
    margin: 0;
    font-size: 40px;
    font-weight: 700;
  }

  p {
    margin: 0;
    opacity: 0.7;
  }


  @media (max-width: 1530px) {
    display: none;
  }
`;

const StatCardLeft = styled(Box)`
  ${StatCardBase}
  top: 280px;
  left: 330px;
  z-index: 99;
`;

const StatCardRight = styled(Box)`
  ${StatCardBase}
  top: 140px;
  right: 430px;
  z-index: 99;
`;

/* Keyframes */
const Keyframes = styled(Box)`
  @keyframes drawLine {
    to {
      stroke-dashoffset: 0;
    }
  }
  
  @keyframes fadeUpCard {
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  @keyframes smoothMovingShadow {
    0% {
      box-shadow: 
        0 2px 3px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 4px 20px rgba(0, 0, 0, 0.3);
    }
    25% {
      box-shadow: 
        1px 0 3px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 4px 20px rgba(0, 0, 0, 0.3);
    }
    50% {
      box-shadow: 
        0 -2px 3px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 4px 20px rgba(0, 0, 0, 0.3);
    }
    75% {
      box-shadow: 
        -1px 0 3px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 4px 20px rgba(0, 0, 0, 0.3);
    }
    100% {
      box-shadow: 
        0 2px 3px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 4px 20px rgba(0, 0, 0, 0.3);
    }
  }

  @keyframes smoothMovingShadowEnhanced {
    0% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    25% {
      box-shadow: 
        1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    50% {
      box-shadow: 
        0 -2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    75% {
      box-shadow: 
        -1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    100% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
  }
`;

const Worldwide = () => {
  const [nodeCount, setNodeCount] = useState(0);
  const [countryCount, setCountryCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);
const resetCounters = () => {
    setNodeCount(0);
    setCountryCount(0);
  };
useEffect(() => {
  const isMobile = window.innerWidth <= 600;

  Aos.init({
    duration: isMobile ? 800 : 2000, 
    offset: isMobile ? 50 : 100, 
    once: true,
    easing: isMobile ? 'ease-out' : 'ease-out-cubic',
    mirror: false,
    disable: false, 
  });

  Aos.refresh();

}, []);

 useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          resetCounters();
          animateCounter();
        }
      });
    },
    {
      threshold: 0.3,
      rootMargin: '0px 0px -100px 0px',
    }
  );

  if (sectionRef.current) {
    observer.observe(sectionRef.current);
  }

  return () => {
    if (sectionRef.current) {
      observer.unobserve(sectionRef.current);
    }
  };
}, []);

  const animateCounter = () => {
    // Animate nodes counter from 0 to 47
    const nodeDuration = 2000; // 2 seconds
    const nodeSteps = 47;
    const nodeInterval = nodeDuration / nodeSteps;

    let currentNode = 0;
    const nodeTimer = setInterval(() => {
      currentNode += 1;
      setNodeCount(currentNode);
      if (currentNode >= 47) {
        clearInterval(nodeTimer);
      }
    }, nodeInterval);

    // Animate countries counter from 0 to 17
    const countryDuration = 1500; // 1.5 seconds
    const countrySteps = 17;
    const countryInterval = countryDuration / countrySteps;

    let currentCountry = 0;
    const countryTimer = setInterval(() => {
      currentCountry += 1;
      setCountryCount(currentCountry);
      if (currentCountry >= 17) {
        clearInterval(countryTimer);
      }
    }, countryInterval);
  };

  return (
    <Wrapper ref={sectionRef}>
      <Keyframes />

      <Container maxWidth="xl">
        <Grid container justifyContent="center" textAlign="center">
          <Heading style={{ zIndex: 99 }} data-aos="fade-up" data-aos-once="false">
            Secure Connections.{' '}
            <span
              style={{
                background:
                  'linear-gradient(160deg, rgb(197, 180, 226) 43%, rgb(168 96 255)) text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontWeight: 'Bolder',
              }}
            >
              Worldwide.
            </span>
          </Heading>

          <Paragraph style={{ zIndex: 99 }} data-aos="fade-up" data-aos-once="false">
            Choose from worldwide locations and stay fully hidden online.
          </Paragraph>

          <Box sx={{ position: 'relative', width: '100%', marginBottom:'20px' }} >
            {/* Desktop World Image */}
            <WorldImage
              component="img"
              src={world}
              alt="world"
              data-aos="fade-up"
              data-aos-once="false"
            />

            {/* Mobile World Image */}
            <WorldMobileImage
              component="img"
              src={worldmobile}
              alt="world mobile"
              data-aos="fade-up"
              data-aos-once="false"
            />

            {/* Left Card - Hidden on mobile */}
            <StatCardLeft data-aos="fade-up" data-aos-once="false">
              <h2>{nodeCount}+</h2>
              <p>Nodes</p>
            </StatCardLeft>

            {/* Right Card - Hidden on mobile */}
            <StatCardRight data-aos="fade-up" data-aos-once="false">
              <h2>{countryCount}+</h2>
              <p>Countries</p>
            </StatCardRight>
          </Box>
        </Grid>
      </Container>

      {/* Node Provider Section */}
      <Container maxWidth="lg">
        <CardSection data-aos="fade-up" data-aos-once="false">
          <Grid container>
            <GridMobile item xs={12} md={6} padding={'60px 80px 80px 60px'}>
              <StyledSubHeading>Become a Node Provider</StyledSubHeading>
              <Paragraph style={{ maxWidth: '510px' }}>
                As a node provider you play a crucial role in maintaining our decentralized infrastructure. By running your own node, you help enhance network security and performance while earning rewards.
              </Paragraph>
              <PurpleButton href="https://app.shadownode.org/node-provider" target="_blank" style={{ padding: '7px 27px', fontSize: '17px' }}>
                Provide a Node
              </PurpleButton>
            </GridMobile>

            <Grid item xs={12} md={6}>
              <img
                src={noderight}
                alt=""
                style={{ width: '100%', maxWidth: '800px', height: '100%' }}
                draggable='false'
              />
            </Grid>
          </Grid>
        </CardSection>
      </Container>
    </Wrapper>
  );
};

export default Worldwide;